'use strict';

import "@babel/polyfill";
require('cross-fetch/polyfill');

